module.exports = __webpack_public_path__ + "static/media/balance.79b87875.svg";